module.exports = __webpack_public_path__ + "img/2f49b9a.png";